import MainLayout from '../../components/layouts/MainLayout';

const PostComplete = () => {

  return(
    <MainLayout>
      <div className='post__comp'>
        <h2 className='login__ttl'>本人確認をお願いします</h2>
        <div className='post__comp-cont'>
          <span>＄1000以上の投稿には本人確認が必要です</span>
          <span>本人未確認の為未公開として投稿を保存しました。本人確認後にMY PAGEより公開へ切り替えをお願いします。</span>
          <p>「有料枠に掲載する」に掲載するをチェックされた方には、GCkoala よりご登録のメールアドレス又はLNEにご案内を送らせていただきます。</p>
        </div>
        <a href='/sharehouse'>一覧ページへ戻る</a>
        <a href='/mypage'>投稿を確認する</a>
      </div>
    </MainLayout>
  );
};

export default PostComplete;
